module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.woff2?dd049a6496eea2a18937237b999ea8fa";